const FesHeader = () => {
  return (
    <header>
      <div className="fixed top-0 p-5 pr-10 h-[80px] flex flex-row items-center justify-between w-full text-white bg-[#d60504]">
        <div className="flex flex-row lg:w-[80%] items-center">
        <div className="header_logo">
          <a href="https://futureofwork.fes.de/">
            <img
              src="/img/test-fes.png"
              className="max-h-36 min-w-[200px]"
              alt="FES's Logo"
            />
          </a>
        </div>
        <div className="text-left text-[16px] ml-5 max-lg:hidden">
          Search for high-quality content on the future of work and the digital
          transition – across text, video and audio, in English, German, French
          and Spanish. Powered by the curation tech – part-algorithmic,
          part-human – developed by{" "}
          <a href="https://the-syllabus.com/" className="text-left text-[16px] underline" rel="noreferrer"  target="_blank">
            The Syllabus
          </a>
          , and presented by FES Future of Work.
        </div>
        </div>
      </div>
    </header>
  );
};
export default FesHeader;
